<template>
  <Select v-model="selected"
          :remote-method="findAccount"
          :loading="loading"
          @on-change="handleValueChanged"
          :placeholder="placeholder"
          filterable
          :clearable="clearable">
    <Option v-for="acc in results" :key="acc.id" :value="acc.id" :label="acc.name + (` (${acc.account_number}) ` || '')">
      {{ acc.name }}<span v-if="acc.account_number"> ({{ acc.account_number }}) </span><span v-if="acc.short_code"> ({{ acc.short_code }}) </span>
    </Option>
  </Select>
</template>

<script>
import { eloquentsearch } from '@/api/search'
export default {
  name: 'AccountSelect',
  props: {
    placeholder: {
      type: String,
      default: 'Find customer'
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      selected: this.$attrs.value,
      results: [],
      loading: false
    }
  },
  methods: {
    findAccount(query) {
      this.loading = true
      eloquentsearch('account', query)
        .then(resp => {
          this.results = resp.data.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleValueChanged(value) {
      this.$emit('input', value)
    }
  },
  watch: {
    '$attrs.value' () {
      this.selected = this.$attrs.value
    }
  }
}
</script>
